export default __webpack_public_path__ + "static/media/020315202130100.52af09f3.png";